module.exports = __webpack_public_path__ + "simquadrat-top-bw.svg?ebe7c68c400d5e17e0e578dce9783a47";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/simquadrat-top-bw.svg
// module id = 69
// module chunks = 0